import {Link} from 'react-router-dom'
import {CSSProperties} from 'react'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {AsideUserMenu} from '../../../partials'
import {useThemeMode} from '../../../partials/layout/theme-mode/ThemeModeProvider'
import {MODULE_PRESENTATION, useModule} from '../../../../app/platform/modules'
import {KTSVG} from '../../../helpers'

type AsideDefaultProps = {
  hideMenuContent?: boolean
}

const AsideDefault = ({hideMenuContent = false}: AsideDefaultProps) => {
  const {classes} = useLayout()
  const {mode} = useThemeMode()
  const {defaultRoute, isModuleSession, module, moduleCode} = useModule()
  const presentation = moduleCode ? MODULE_PRESENTATION[moduleCode] : undefined
  return (
    <div
      id='kt_aside'
      className={clsx('aside py-9', classes.aside.join(' '), {
        'aside--module': isModuleSession,
        'aside--legacy': !isModuleSession,
      })}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto px-9 mb-9' id='kt_aside_logo'>
        {/* begin::Logo */}
        {isModuleSession && module && presentation ? (
          <Link to={defaultRoute} className='nosi-aside-module-brand'>
            <span
              className='nosi-aside-module-brand__icon'
              style={{'--nosi-module-accent': presentation.accent} as CSSProperties}
            >
              <KTSVG path={presentation.icon} className='svg-icon-2' />
            </span>
            <span className='nosi-aside-module-brand__copy'>
              <small>Aktif modül</small>
              <strong>{module.displayName}</strong>
            </span>
          </Link>
        ) : (
          <Link to='/dashboard'>
            {mode === 'light' && (
              <img
                alt='Logo'
                className='h-100px logo theme-light-show'
                src={toAbsoluteUrl('/media/logos/gradeurexam2.png')}
              />
            )}

            {mode === 'dark' && (
              <img
                alt='Logo'
                className='h-100px logo theme-dark-show'
                src={toAbsoluteUrl('/media/logos/gradeurexam.png')}
              />
            )}
          </Link>
        )}
        {/* end::Logo */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div id='kt_aside_menu' className='aside-menu flex-column-fluid ps-5 pe-3 mb-9'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} hideMenuContent={hideMenuContent} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      <div className='aside-footer flex-column-auto px-9' id='kt_aside_footer'>
        <AsideUserMenu />
      </div>
      {/* end::Footer */}
    </div>
  )
}

export {AsideDefault}
